import type { FunctionComponent } from 'react'
import { Translation } from '../../contexts/TranslationContext'
import style from './ManufacturerArticle.module.sass'

type ManufacturerArticleProps = {
	manufacturer: JSX.Element[] | undefined
	countriesOfProduction?: JSX.Element[]
	residence: (JSX.Element | undefined)[] | undefined
	distributor: JSX.Element | undefined
}

export const ManufacturerArticle: FunctionComponent<ManufacturerArticleProps> = ({
	manufacturer,
	countriesOfProduction,
	residence,
	distributor,
}) => {
	return (
		<div className={style.wrapper}>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="manufacturerArticle.manufacturer.title" />
				</div>
				<div className={style.value}>
					{manufacturer || (
						<span className={style.italic}>
							<Translation tr="manufacturerArticle.notSpecified" />
						</span>
					)}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="manufacturerArticle.distributor.title" />
				</div>
				<div className={style.value}>
					{distributor || (
						<span className={style.italic}>
							<Translation tr="manufacturerArticle.notSpecified" />
						</span>
					)}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="manufacturerArticle.residence.title" />
				</div>
				<div className={style.value}>
					{residence || (
						<span className={style.italic}>
							<Translation tr="manufacturerArticle.notSpecified" />
						</span>
					)}
				</div>
			</div>
			<div className={style.row}>
				<div className={style.title}>
					<Translation tr="manufacturerArticle.countriesOfProduction.title" />
				</div>
				<div className={style.value}>
					{countriesOfProduction || (
						<span className={style.italic}>
							<Translation tr="manufacturerArticle.notSpecified" />
						</span>
					)}
				</div>
			</div>
		</div>
	)
}
